export default "__VITE_ASSET__COVZOPqH__"